var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHideComments(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.71,5.29l.29,.71V15l-.29,.71-2,2-.71,.29h-6.43l-2.71,4.51h-1.71l-1.7-2.84,1.46-1.46,1.1,1.84,2.14-3.57,.86-.49h6.59l1.41-1.41V6.41l-.15-.15,1.41-1.41,.44,.44ZM3.63,20.66l-1.41-1.41,1.4-1.4-.32-.13-2-2-.29-.71V6l.29-.71L3.29,3.29l.71-.29h14.46l2.27-2.27,1.41,1.41L3.63,20.66Zm1.83-4.66L16.46,5H4.41l-1.41,1.41V14.59l1.41,1.41h1.04Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHideComments);
export default __webpack_public_path__ + "static/1777458306/media/icon-hide-comments.d72ab4e003f3d3958a6ccf3022a7fe05.svg";
export { ForwardRef as ReactComponent };